<template>
  <form class="form popup__form" @submit.prevent="sendForm" ref="formCentralized">
    <div class="form__body" v-show="!success">
      <div class="form__items">
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_21']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="text" :placeholder="fieldNamePlaceholder"
                     @input="clearErrors" v-model="form.form_text_21">
              <label class="default-input__label">{{ fieldName }}</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_21'] }}</span></div>
          </div>
        </div>
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_22']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="email" placeholder="E-mail"
                     @input="clearErrors" v-model="form.form_text_22">
              <label class="default-input__label">E-mail</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_22'] }}</span></div>
          </div>
        </div>
        <div class="form__item">
          <div class="default-input">
            <div class="default-input__body">
              <input class="default-input__input" type="text" :placeholder="fieldCompany"
                     @input="clearErrors" v-model="form.form_text_23">
              <label class="default-input__label">{{ fieldCompany }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="form__submit">
        <button class="form__submit-btn default-btn default-btn--green" type="submit">{{ submitTile }}
          <svg class="default-btn__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-link"></use>
          </svg>
        </button>

        <p class="form__policy">{{ policy1 }} <a class="link link--base" :href="agreement"
                                                            target="_blank">{{ policy2 }}</a>
          {{ policy3 }} <a class="link link--base" :href="policy" target="_blank">{{ policy4 }}</a></p>
      </div>
    </div>

    <div class="form__confirm" v-show="success">
      <p>{{ confirm1 }}</p>
      <p>{{ confirm2 }}</p>
    </div>
  </form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "CompanyForm",
  data() {
    return {
      form: {
        form_text_21: '',
        form_text_22: '',
        form_text_23: '',
      },
      errors: {},
      success: false,
    }
  },
  props: {
    agreement: String,
    policy: String,
    code: String,
    language: {
      type: [String],
      default: 'ru'
    },
    fieldName: {
      type: [String],
      default: BX.message('FORM_FIELD_NAME')
    },
    fieldNamePlaceholder: {
      type: [String],
      default: BX.message('FORM_FIELD_NAME_PLACEHOLDER')
    },
    fieldCompany: {
      type: [String],
      default: BX.message('FORM_FIELD_COMPANY')
    },
    submitTile: {
      type: [String],
      default: BX.message('FORM_SUBMIT_1')
    },
    policy1: {
      type: [String],
      default: BX.message('FORM_POLICY_1')
    },
    policy2: {
      type: [String],
      default: BX.message('FORM_POLICY_2')
    },
    policy3: {
      type: [String],
      default: BX.message('FORM_POLICY_3')
    },
    policy4: {
      type: [String],
      default: BX.message('FORM_POLICY_4')
    },
    confirm1: {
      type: [String],
      default: BX.message('FORM_CONFIRM_1')
    },
    confirm2: {
      type: [String],
      default: BX.message('FORM_CONFIRM_2')
    },
  },
  computed: {
    ...mapState(['moduleWebForm']),
    result() {
      if (this.moduleWebForm.formArray)
        return Object.values(this.moduleWebForm.formArray)
      else
        return []
    }
  },
  methods: {
    sendForm() {
      let formData = new FormData
      formData.set('data', JSON.stringify(this.form))
      formData.append('formCode', this.code)
      formData.append('requiredFields[]', 'form_text_21')
      formData.append('requiredFields[]', 'form_text_22')
      formData.append('language', this.language);

      fetch('/api/webform/add/', {
        method: 'POST',
        body: formData
      })
          .then(response => response.json())
          .then(result => {
            if ('data' in result) {
              this.form = {}
              this.success = true
              setTimeout(() => {
                this.success = false
              }, 5000)
            } else {
              let message = JSON.parse(result.message)
              this.errors = message.errors

              const targetElement = this.$refs['formCentralized'];
              if (window.locoScroll) {
                window.locoScroll.scrollTo(targetElement, {
                  offset: document.querySelector('.header') ? -(document.querySelector('.header').offsetHeight + 50) : 0,
                })
              } else {
                const yOffset = -100;
                const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
              }
            }
          })
    },
    clearErrors() {
      this.errors = {};
    },
  },
  created() {
    this.$store.dispatch('getForm', this.code)
  }
}
</script>